// src/lib/pdfAnzeige.js
// PDF IN DER APP anzeigen und die Unterschriftszeile finden (Anna-Lena 21.09.2026).
//
// Warum in der App: "In neuem Fenster oeffnen" verhaelt sich auf iPhone-App und
// Android unterschiedlich (mal Download, mal gar nichts). Mit pdf.js wird jede
// Seite als Bild gezeichnet - ueberall gleich, auch ohne Netz.
//
// Warum Suchen: Die Unterschriftslinie liegt je nach Lieferschein woanders. Die
// App sucht das Wort "Unterschrift" (o. ae.) und schlaegt die Stelle vor; der
// Monteur kann mit einem Tipp korrigieren.
//
// pdf.js ist gross und wird erst beim ersten Oeffnen geladen (eigener Teil des
// Programms, liegt fuer ohne Netz im Speicher des Service Workers). Der Worker
// laeuft im Hauptfaden ("fake worker") - fuer Lieferscheine mit 1-3 Seiten
// voellig ausreichend und ohne Extra-Datei, die offline fehlen koennte.

let laden = null;
function pdfjsLaden() {
  if (!laden) {
    laden = (async () => {
      const [pdfjs, worker] = await Promise.all([
        import('pdfjs-dist/legacy/build/pdf'),
        import('pdfjs-dist/legacy/build/pdf.worker'),
      ]);
      // pdf.js nimmt diesen Worker, wenn er global bereitliegt.
      window.pdfjsWorker = worker;   // globalThis im Browser = window
      return pdfjs;
    })();
    laden.catch(() => { laden = null; });
  }
  return laden;
}

// Dokument oeffnen. blob: PDF-Datei.
export async function pdfOeffnen(blob) {
  const pdfjs = await pdfjsLaden();
  const daten = new Uint8Array(await blob.arrayBuffer());
  return pdfjs.getDocument({ data: daten, isEvalSupported: false }).promise;
}

// Eine Seite in eine Leinwand zeichnen. breite: Anzeigebreite in CSS-Pixeln.
// Rueckgabe: viewport (zum Umrechnen zwischen Bildschirm und PDF).
export async function seiteZeichnen(doc, nummer, leinwand, breite) {
  const seite = await doc.getPage(nummer);
  const basis = seite.getViewport({ scale: 1 });
  const dichte = Math.min(window.devicePixelRatio || 1, 2);
  const massstab = (breite / basis.width) * dichte;
  const viewport = seite.getViewport({ scale: massstab });
  leinwand.width = Math.floor(viewport.width);
  leinwand.height = Math.floor(viewport.height);
  leinwand.style.width = Math.floor(viewport.width / dichte) + 'px';
  leinwand.style.height = Math.floor(viewport.height / dichte) + 'px';
  const ctx = leinwand.getContext('2d');
  await seite.render({ canvasContext: ctx, viewport }).promise;
  return { viewport, dichte };
}

// Woerter, an denen man eine Unterschriftszeile erkennt.
const HINWEISE = /(unterschrift|unterzeichn|empfang|erhalten|abgenommen|best[aä]tig|signature)/i;

// Vorschlag fuer die Unterschrift: { seite, x, y } in PDF-Koordinaten (Ursprung
// unten links), y = Hoehe der Linie. Gesucht wird von der letzten Seite rueckwaerts,
// auf einer Seite der UNTERSTE Treffer. Ohne Treffer: null.
export async function unterschriftsstelleFinden(doc) {
  for (let n = doc.numPages; n >= 1; n--) {
    const seite = await doc.getPage(n);
    const inhalt = await seite.getTextContent();
    const treffer = inhalt.items
      .filter(it => it && typeof it.str === 'string' && HINWEISE.test(it.str))
      .map(it => ({ str: it.str.trim(), x: it.transform[4], y: it.transform[5],
                    breite: it.width || 0, hoehe: it.height || Math.abs(it.transform[3]) || 8 }))
      .sort((a, b) => a.y - b.y);
    if (treffer.length === 0) continue;
    const t = treffer[0];
    // "Unterschrift:" mit Doppelpunkt -> die Linie folgt rechts daneben.
    if (/[:]\s*$/.test(t.str)) return { seite: n, x: t.x + t.breite + 6, y: t.y - 1 };
    // Sonst steht die Beschriftung meist UNTER der Linie -> knapp darueber unterschreiben.
    return { seite: n, x: t.x, y: t.y + t.hoehe + 3 };
  }
  return null;
}
